module.exports = __webpack_public_path__ + "static/media/icw_awardListImg.e88fa906.svg";